import { Box } from 'libs/ui';
import { styled } from 'libs/ui/styled';

export const Content = styled(Box)(() => ({
  padding: '24px 32px 105px 32px',
}));
